import { isNil } from '@grandvisionhq/utils';

var PaymentStatusLabelKey;
(function(PaymentStatusLabelKey) {
    PaymentStatusLabelKey["BALANCE_DUE"] = 'balanceDue';
    PaymentStatusLabelKey["CREDIT_OWED"] = 'creditOwed';
    PaymentStatusLabelKey["FAILED"] = 'failed';
    PaymentStatusLabelKey["PAID"] = 'paid';
    PaymentStatusLabelKey["PENDING"] = 'pending';
})(PaymentStatusLabelKey || (PaymentStatusLabelKey = {}));
const getPaymentStatusLabel = (status, intl)=>{
    if (isNil(status)) {
        return undefined;
    }
    return intl.getLabel(`account.order.paymentStatus.${PaymentStatusLabelKey[status]}`);
};

export { getPaymentStatusLabel };
//# sourceMappingURL=get-payment-status-label.js.map
